import { motion } from "framer-motion";

export const Reveal = ({
  children,
  delay = 0,
  y = 24,
  duration = 0.8,
  className = "",
  once = true,
  ...rest
}) => (
  <motion.div
    className={className}
    initial={{ opacity: 1, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, amount: 0.05, margin: "0px 0px -8% 0px" }}
    transition={{ duration, delay, ease: [0.16, 1, 0.3, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const RevealStagger = ({ children, className = "", stagger = 0.1 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, amount: 0.05, margin: "0px 0px -8% 0px" }}
    transition={{ staggerChildren: stagger }}
  >
    {children}
  </motion.div>
);

export const revealItem = {
  hidden: { opacity: 1, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] } },
};
